import type { NavigationItem } from './AppShell'

interface MainNavProps {
  items: NavigationItem[]
  onNavigate?: (href: string) => void
}

export function MainNav({ items, onNavigate }: MainNavProps) {
  return (
    <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
      {items.map((item) => (
        <button
          key={item.href}
          onClick={() => onNavigate?.(item.href)}
          className={`
            w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium
            transition-colors duration-150
            ${
              item.isActive
                ? 'bg-teal-50 text-teal-600 border border-teal-200 dark:bg-teal-950 dark:text-teal-400 dark:border-teal-800'
                : 'text-stone-600 hover:bg-stone-100 hover:text-stone-900 border border-transparent dark:text-stone-400 dark:hover:bg-stone-800 dark:hover:text-stone-100'
            }
          `}
        >
          {item.icon && (
            <span className={`w-5 h-5 ${item.isActive ? '' : 'text-stone-500 dark:text-stone-500'}`}>
              {item.icon}
            </span>
          )}
          <span className="flex-1 text-left">{item.label}</span>
          {item.badge !== undefined && item.badge !== false && (
            <span
              className={`
                flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full text-xs font-medium
                ${
                  typeof item.badge === 'number'
                    ? 'bg-teal-100 text-teal-700 dark:bg-teal-900 dark:text-teal-300'
                    : 'w-2 h-2 min-w-0 px-0 bg-amber-500'
                }
              `}
            >
              {typeof item.badge === 'number' ? item.badge : ''}
            </span>
          )}
        </button>
      ))}
    </nav>
  )
}
